import { helpers } from 'vuelidate/lib/validators'
export default value => !helpers.req(value) || /(\d{2}\/\d{2}\/\d{4})/.test(value)
